import { asContainer } from 'lib/container'

export const container = asContainer<{}>()({
	path: '/recover-login',
	authentication: { type: 'public' },
	Running: () => <div>Recover login</div>,
})
